import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Home } from '@material-ui/icons';
import appConstant from '../../appConstants';
import AnimationRenderer from '../animations/animationRenderer';
import * as RMAXErrorAnimation from '../animations/json/RMAXErrorAnimation.json';

// Using hardcoded colors since this page should be independent of the theme
const styles = {
  pageContainerBg: {
    background: 'url(./../../images/RMaxErrorBG-light.jpg)',
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    '& > *': {
      boxSizing: 'border-box'
    }
  },
  pageBg: {
    background: 'url(./../../images/RMaxErrorBG-light.jpg)',
    width: '1400px',
    height: '755px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    borderRadius: '20px',
    position: 'relative'
  },
  container: {
    display: 'flex',
    '@media (max-width: 1024px)': {
      width: '80%'
    }
  },
  subContainer: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    padding: 20,
  },
  pageAnimationContainer: {
    transform: 'translate(-55%, 2%)'
  },
  messageTitle: {
    fontSize: 44,
    color: 'rgba(12, 107, 185, 1)',
    fontWeight: 700,
    '@media (max-width: 480px)': {
      fontSize: 28
    },
    fontFamily: 'Oxanium !important',
  },
  statusCode: {
    color: 'rgba(46, 59, 88, 1)',
    fontSize: 128,
    fontWeight: 700,
    height: '154px',
    fontFamily: 'Oxanium !important',
  },
  messageContent: {
    color: '#666666',
    maxWidth: '492px',
    textAlign: 'left',
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '27px',
    margin: '10 0',
    '@media (max-width: 480px)': {
      fontSize: 14
    },
    fontFamily: 'Roboto Mono !important',
  },
  homeButton: {
    width: 150,
    marginTop: 16,
    backgroundColor: 'rgba(12, 107, 185, 1)',
    textTransform: 'none',
    height: 44
  },
  link: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    color: '#FFFFFF',
    fontSize: 18
  },
  icon: {
    marginRight: '8px',
    fontSize: 22
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center'
  },
  customMessage: {
    marginTop: 24,
    color: '#E5A70D',
    fontSize: 20,
    fontWeight: 600
  }
};

const PageNotFound = (props) => {
  const { classes, customMessage } = props;
  const label = props.errorLabel ?? 'Page not found';
  const description = props.errorDescription ?? 'It looks like we couldn’t find the page you’re looking for.';
  const statusCode = props.statusCode ?? 404;
  return (
    <div className={classes.pageContainerBg}>
      <div className={classes.pageBg}>
        <div className={classes.container}>
          <div className={classes.pageAnimationContainer}>
            <AnimationRenderer dimension={600} animationJSON={RMAXErrorAnimation} />
          </div>
          <div className={classes.subContainer}>
            <div className={classes.statusCode}>{statusCode}</div>
            <div className={classes.messageTitle}>{label}</div>
            <div className={classes.messageContent}>{description}</div>
            {customMessage && (
              <div className={classes.customMessage}>{customMessage}</div>
            )}
            {props.children || (
              <Button color="primary" variant="contained" classes={{ root: classes.homeButton }}>
                <Link to={appConstant.NAV_URLS.IBPLANNING_HOME} className={classes.link}>
                  <div className={classes.linkContent}>
                    <Home className={classes.icon} />
                    Home
                  </div>
                </Link>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(PageNotFound);
